<template>
    <div class="webBar"></div>
</template>

<script>
export default {
    name: 'chart2',
    props: {
        data: Object,
        pondsid:Number,
        companyId: Number,
        greenhouseId: Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            fullDateData: [], // 保存完整的日期时间，用于tooltip显示
            yData:{
                hum1: [],
                hum2: [],
                hum3: []
            },
            yAxisMin: null, 
            timerSetChart: null, // 用于存储setChart的定时器
            timerGetData: null, // 用于存储getData的定时器// 用于存储动态的y轴最小值
        }
    },
    methods: {
        updateWithDateRange(start, end) {
            // 使用新的 /sensors/history-by-time 接口，支持精确时间
            const params = {
                greenhouseId: this.greenhouseId,
                startDate: start,
                endDate: end,
                pageNum: 1,
                pageSize: 1000
            };
            this.request.get("/api/sensors/history-by-time", {
                params: params
            }).then(res => {
                // 处理返回结果，支持 Result 包装格式
                const list = Array.isArray(res) ? res :
                             (res && Array.isArray(res.data)) ? res.data :
                             (res && Array.isArray(res.records)) ? res.records : [];
                // 按时间正序排序（最旧的在前，最新的在右）
                const sortedList = [...list].sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
                // 保存完整日期时间用于tooltip
                this.fullDateData = sortedList.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = sortedList.map(item => {
                    const dateTime = item.createdAt ? item.createdAt.split('T') : [];
                    return dateTime[1] ? dateTime[1].substring(0, 5) : ''; // 只显示时:分
                });
                this.yData = {
                    hum1: sortedList.map(item => item.hum1 != null ? item.hum1 : 0),
                    hum2: sortedList.map(item => item.hum2 != null ? item.hum2 : 0),
                    hum3: sortedList.map(item => item.hum3 != null ? item.hum3 : 0)
                };
                this.updateDynamicYAxis();
                this.setChart()
            }).catch(err => {
                console.error('获取历史数据失败:', err);
            });
        },
        setData() {
            this.request.get("/api/sensors/latest", {
                params: {
                    companyId: this.companyId,
                    greenhouseId: this.greenhouseId
                }
            }).then(res => {
                const list = Array.isArray(res) ? res :
                              (res && Array.isArray(res.data) ? res.data :
                              (res && Array.isArray(res.records) ? res.records : []));
                // 按时间正序排序（最旧的在前，最新的在右）
                const sortedList = [...list].sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
                // 保存完整日期时间用于tooltip
                this.fullDateData = sortedList.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = sortedList.map(item => {
                    const dateTime = item.createdAt.split('T')
                    return dateTime[1] ? dateTime[1].substring(0, 5) : ''; // 只显示时:分
                });
                this.yData = {
                    hum1: sortedList.map(item => item.hum1 != null ? item.hum1 : 0),
                    hum2: sortedList.map(item => item.hum2 != null ? item.hum2 : 0),
                    hum3: sortedList.map(item => item.hum3 != null ? item.hum3 : 0)
                };
                this.updateDynamicYAxis();
                this.setChart()
            })
        },
        updateDynamicYAxis() {
            const allValues = [...this.yData.hum1, ...this.yData.hum2, ...this.yData.hum3];
            if (allValues.length > 0) {
                const minVal = Math.min(...allValues);
                this.yAxisMin = minVal - 0.1; // 减去0.1以确保所有数据都能清晰显示
            }
        },
        // 网站
        setChart() {
            const self = this; // 保存this引用
            let option = {
                textStyle: {
                    color: '#fff'
                },
                title:{
                    text: '湿度变化',
                    left: "center",
                    top: '5%',
                    textStyle: {
                        color: "#fff",
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                    type: 'shadow'
                    },
                    formatter: function(params) {
                        let result = '';
                        if (params && params.length > 0) {
                            const index = params[0].dataIndex;
                            const fullDate = self.fullDateData[index];
                            // 格式化完整日期时间
                            if (fullDate) {
                                const dateTime = fullDate.replace('T', ' ');
                                result = dateTime + '<br/>';
                            }
                            params.forEach(param => {
                                result += `${param.seriesName}: ${param.value}%RH<br/>`;
                            });
                        }
                        return result;
                    }
                },
                grid: {
                    left: '8%',
                    right: '8%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                    type: 'category',
                    data: this.xData,
                    axisTick: {
                        alignWithLabel: true,
                        
                    }
                    }
                ],
                yAxis: [
                {
                    type: 'value',
                    min: this.yAxisMin, // 根据你的数据范围调整最小值 // 根据你的数据范围调整最大值
                    // interval: 0.5, // 设置 y 轴刻度间隔
                    axisLabel: {
                        formatter: function (value) {
                            return value.toFixed(2); // 保留两位小数
                        }
                    },
                    name: '(%RH)',
                    nameTextStyle: {
                        color: '#fff',
                        fontSize: 11,
                        align: 'right',
                    }
                }
                ],
                legend: {
                    data: ['湿度1', '湿度2', '湿度3'],
                    left: 'left',
                    top: 'top',
                    orient: 'horizontal',
                    itemGap: 20,
                    selected: {
                        '湿度1': true,
                        '湿度2': true,
                        '湿度3': true
                    },
                    textStyle: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                    name: '湿度1',
                    type: 'bar',
                    data: this.yData.hum1,
                    itemStyle: {
                        color: "#9999ff"
                    },
                    animationDuration: 50000,
                    animationDelay: function () {
                        return Math.random() * 200;
                    },
                    animationEasing: 'elasticOut',
                    },
                    {
                    name: '湿度2',
                    type: 'bar',
                    data: this.yData.hum2,
                    itemStyle: {
                        color: "#66ccff"
                    },
                    animationDuration: 50000,
                    animationDelay: function () {
                        return Math.random() * 200;
                    },
                    animationEasing: 'elasticOut',
                    },
                    {
                    name: '湿度3',
                    type: 'bar',
                    data: this.yData.hum3,
                    itemStyle: {
                        color: "#3399ff"
                    },
                    animationDuration: 50000,
    animationDelay: function () {
                        return Math.random() * 200;
    },
    animationEasing: 'elasticOut',
                    }
                ]
            };         
            if (!this.myChart) this.myChart = this.$echarts(this.$el);
            // this.request.get("/user/echart").then(res => {
            //     option.series[0].data = res
            //     this.myChart.clear();
            //     this.myChart.resize();
            //     this.myChart.setOption(option);
            // })
            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        },
    },
    mounted() {
        // 移除 mounted 中的 setData，只依赖 watch 触发
        // 启动定时器，每2分钟刷新图表，每5分钟获取新数据
        this.timerSetChart = setInterval(() => {
            this.setChart();
        }, 2 * 60 * 1000); // 2分钟

        // 每五分钟执行一次setData
        this.timerGetData = setInterval(() => {
            // 只有当有有效数据时才刷新
            if (this.greenhouseId) {
                this.setData();
            }
        }, 5 * 60 * 1000); // 5分钟
    },
    watch: {
        pondsid() {
            this.setData();
        },
        greenhouseId() {
            this.setData();
        },
        companyId() {
            this.setData();
        }
    },
    beforeDestroy() {
        // 清除定时器
        if (this.timerSetChart) {
            clearInterval(this.timerSetChart);
        }
        if (this.timerGetData) {
            clearInterval(this.timerGetData);
        }
    }
};

</script>

<style lang="less" scoped>
.webBar {
    width: 95%;
    height: 100%;
}
</style>